import type { SearchSuggestions } from "mws-ts-v2-sdk";

const STORAGE_NAME = "searchHistoryItems";
const STORAGE_AMOUNT = 4;

export type SearchHistoryItem = SearchSuggestions | string;

export const getSearchHistoryName = (searchTerm: SearchHistoryItem): string => {
  return typeof searchTerm === "string" ? searchTerm : searchTerm.name;
};

const useSearchHistory = () => {
  const storage = useStorageSafely<SearchHistoryItem[]>({
    type: "localStorage",
    key: STORAGE_NAME,
    defaultValue: [],
  });

  const onAddSearchHistory = (search: SearchHistoryItem) => {
    // Copy storage so we don't directly manipulate the values
    let storageCopy = [...storage.value];

    // Remove value if it's already in the array
    const doubleValueIndex = storageCopy.findIndex((storageItem) => {
      return (
        getSearchHistoryName(storageItem).toLowerCase().trim() ===
        getSearchHistoryName(search).toLowerCase().trim()
      );
    });
    if (doubleValueIndex > -1) {
      storageCopy.splice(doubleValueIndex, 1);
    }

    // Move new value to the top
    storageCopy.unshift(search);

    // Ensure we only have 4 results
    storageCopy = storageCopy.slice(0, STORAGE_AMOUNT);

    // Set the new storage values
    storage.value = storageCopy;
  };

  const onClearSearchHistory = () => {
    storage.value = [];
  };

  return {
    searchHistory: storage,
    addSearchHistory: onAddSearchHistory,
    clearSearchHistory: onClearSearchHistory,
  };
};

export default useSearchHistory;
